// extracted by mini-css-extract-plugin
module.exports = {"index":"SCSS_index__1dAs0","btn":"SCSS_btn__23e-U"};